/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Prize } from '../../../../api/models/prize';
import { TableColumn } from '../../../models/table-column';
import { Promotion } from '../../../../api/models/promotion';
import { FormControl } from '@angular/forms';
import { stripHtmlTags } from '../../../helpers/strip-html-tags.helper';

@Component({
  selector: 'app-prizes-table',
  templateUrl: './prizes-table.component.html',
  styleUrl: './prizes-table.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PrizesTableComponent {
  @Input() prizes: Prize[] = [];
  @Input() promotion: Promotion | undefined;

  descriptionPopup = {
    isOpen: false,
    text: new FormControl<string>(''),
  };

  prizeColumns: TableColumn[] = [
    {
      type: 'text',
      label: 'MANAGEMENT.PRIZE.TIER',
      key: 'tier',
    },
    {
      type: 'text',
      label: 'MANAGEMENT.PRIZE.ID',
      key: 'prizeId',
    },
    {
      type: 'link',
      label: 'MANAGEMENT.PRIZE.DESCRIPTION',
      linkAction: this.openPrizeDescription.bind(this),
      linkText: 'MANAGEMENT.PRIZE.VIEW_MORE_LINK',
    },
    {
      type: 'radio-group',
      label: 'MANAGEMENT.PRIZE.IS-AUDITABLE',
      options: [
        { key: 'auditable', value: true, label: '' },
        { key: 'auditable', value: false, label: '' },
      ],
      initialOptionKey: 'auditable',
      testId: 'is-auditable-prize',
      onOptionChanged: this.updateAuditablePrize.bind(this),
      disabled: this.hasPromoStarted.bind(this),
      show: true,
    },
  ];

  updateAuditablePrize(prize: unknown, auditable: any) {
    const prizeParsed: Prize = prize as Prize;
    const auditableParsed: boolean = auditable.value as boolean;

    const foundPrize = this.prizes.find(
      (p) => p.prizeId === prizeParsed.prizeId,
    );

    if (foundPrize) {
      foundPrize.auditable = auditableParsed;
    }
  }

  hasPromoStarted(): boolean {
    if (!this.promotion || !(this.promotion.goLiveDate || this.promotion.startDate)) {
      return false;
    }

    const today = new Date();
    const startDate = new Date(this.promotion.goLiveDate || this.promotion.startDate);

    return startDate <= today;
  }

  openPrizeDescription(row: unknown) {
    this.descriptionPopup.isOpen = true;
    this.descriptionPopup.text.patchValue(stripHtmlTags((row as Prize).description) ?? null);
  }
}
